import React from "react";
import {
  Box,
  Paper,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Chip,
  Alert,
  Divider,
} from "@mui/material";

const FormGuidelines = ({ compact = false }) => {
  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 3 }}>

      {/* Section 2: Required Standard Keys */}
      <Paper elevation={2} sx={{ p: 2.5, bgcolor: "#fff3cd", border: "2px solid #ffc107" }}>
        <Typography variant="h6" sx={{ mb: 2, display: "flex", alignItems: "center", gap: 1, color: "#e65100", fontWeight: 600 }}>
          ⚠️ Required Standard Keys
        </Typography>
        <Typography variant="body2" paragraph fontWeight={500}>
          These keys MUST be used consistently across all forms:
        </Typography>
        <TableContainer component={Paper} elevation={1} sx={{ mt: 2 }}>
          <Table size="small">
            <TableHead>
              <TableRow sx={{ bgcolor: "#f5f5f5" }}>
                <TableCell sx={{ fontWeight: 700 }}>Key</TableCell>
                <TableCell sx={{ fontWeight: 700 }}>Type</TableCell>
                <TableCell sx={{ fontWeight: 700 }}>Description</TableCell>
                <TableCell sx={{ fontWeight: 700 }}>IsFilter</TableCell>
                <TableCell sx={{ fontWeight: 700 }}>IsEmployerVisible</TableCell>
                <TableCell sx={{ fontWeight: 700 }}>Required</TableCell>
                <TableCell sx={{ fontWeight: 700 }}>Region Filter</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <TableRow>
                <TableCell><code style={{ bgcolor: '#e3f2fd', padding: '2px 6px', borderRadius: '4px', fontWeight: 600 }}>fullName</code></TableCell>
                <TableCell><Chip label="text" size="small" color="primary" variant="outlined" /></TableCell>
                <TableCell>User's name</TableCell>
                <TableCell>false</TableCell>
                <TableCell>false</TableCell>
                <TableCell>true</TableCell>
                <TableCell>--</TableCell>
              </TableRow>
              <TableRow>
                <TableCell><code style={{ bgcolor: '#e3f2fd', padding: '2px 6px', borderRadius: '4px', fontWeight: 600 }}>dob</code></TableCell>
                <TableCell><Chip label="Date DOB" size="small" color="primary" variant="outlined" /></TableCell>
                <TableCell>User's DOB</TableCell>
                <TableCell>true</TableCell>
                <TableCell>false</TableCell>
                <TableCell>true</TableCell>
                <TableCell>--</TableCell>
              </TableRow>
              <TableRow>
                <TableCell><code style={{ bgcolor: '#e3f2fd', padding: '2px 6px', borderRadius: '4px', fontWeight: 600 }}>currentAddress</code></TableCell>
                <TableCell><Chip label="Location" size="small" color="primary" variant="outlined" /></TableCell>
                <TableCell>User's Current Address</TableCell>
                <TableCell>--</TableCell>
                <TableCell>false</TableCell>
                <TableCell>true</TableCell>
                <TableCell>true</TableCell>
              </TableRow>
              <TableRow>
                <TableCell><code style={{ bgcolor: '#e3f2fd', padding: '2px 6px', borderRadius: '4px', fontWeight: 600 }}>workRadius</code></TableCell>
                <TableCell><Chip label="radio" size="small" color="primary" variant="outlined" /></TableCell>
                <TableCell>User's preffered work radius</TableCell>
                <TableCell>false</TableCell>
                <TableCell>false</TableCell>
                <TableCell>true</TableCell>
                <TableCell>--</TableCell>
              </TableRow>
              <TableRow>
                <TableCell><code style={{ bgcolor: '#e3f2fd', padding: '2px 6px', borderRadius: '4px', fontWeight: 600 }}>experience</code></TableCell>
                <TableCell><Chip label="Dropdown" size="small" color="primary" variant="outlined" /></TableCell>
                <TableCell>User's Experience</TableCell>
                <TableCell>true</TableCell>
                <TableCell>true</TableCell>
                <TableCell>true</TableCell>
                <TableCell>--</TableCell>
              </TableRow>
              <TableRow>
                <TableCell style={{ display: "flex", flexDirection: "column" }}><code style={{ bgcolor: '#e3f2fd', padding: '2px 6px', borderRadius: '4px', fontWeight: 600 }}>gender</code>
                  <span><code style={{ fontSize: '0.75rem' }}>male</code>, <code style={{ fontSize: '0.75rem' }}>female</code>, <code style={{ fontSize: '0.75rem' }}>prefer_not_to_say</code></span></TableCell>
                <TableCell><Chip label="gender" size="small" color="primary" variant="outlined" /></TableCell>
                <TableCell>User's Gender</TableCell>
                <TableCell>true</TableCell>
                <TableCell>true</TableCell>
                <TableCell>true</TableCell>
                <TableCell>--</TableCell>
              </TableRow>


            </TableBody>
          </Table>
        </TableContainer>
      </Paper>

      {/* Section 6: Field Types Reference */}
      {!compact && (
        <Paper elevation={2} sx={{ p: 2.5, bgcolor: "#e7f5ff", border: "2px solid #74c0fc" }}>
          <Typography variant="h6" sx={{ mb: 2, display: "flex", alignItems: "center", gap: 1, color: "#0c8599", fontWeight: 600 }}>
            📝 Available Field Types
          </Typography>
          <TableContainer component={Paper} elevation={1}>
            <Table size="small">
              <TableHead>
                <TableRow sx={{ bgcolor: "#f5f5f5" }}>
                  <TableCell sx={{ fontWeight: 700 }}>Type</TableCell>
                  <TableCell sx={{ fontWeight: 700 }}>Use Case</TableCell>
                  <TableCell sx={{ fontWeight: 700 }}>Example Key</TableCell>
                  <TableCell sx={{ fontWeight: 700 }}>Options</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                <TableRow>
                  <TableCell><Chip label="text" size="small" color="primary" variant="outlined" /></TableCell>
                  <TableCell>Short text input</TableCell>
                  <TableCell><code style={{ fontSize: '0.75rem' }}>firstName</code>, <code style={{ fontSize: '0.75rem' }}>city</code></TableCell>
                  <TableCell >--</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell><Chip label="email" size="small" color="secondary" variant="outlined" /></TableCell>
                  <TableCell>Email addresses</TableCell>
                  <TableCell><code style={{ fontSize: '0.75rem' }}>email</code></TableCell>
                  <TableCell >--</TableCell>
                </TableRow>

                <TableRow>
                  <TableCell><Chip label="date DOB" size="small" color="success" variant="outlined" /></TableCell>
                  <TableCell>Date selection</TableCell>
                  <TableCell><code style={{ fontSize: '0.75rem' }}>dateOfBirth</code></TableCell>
                  <TableCell >--</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell><Chip label="dropdown" size="small" color="warning" variant="outlined" /></TableCell>
                  <TableCell>Single selection from list</TableCell>
                  <TableCell><code style={{ fontSize: '0.75rem' }}>yearsOfExperience</code></TableCell>
                  <TableCell >--</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell><Chip label="gender" size="small" color="primary" variant="outlined" /></TableCell>
                  <TableCell>Single selection (visible)</TableCell>
                  <TableCell><code style={{ fontSize: '0.75rem' }}>gender</code></TableCell>
                  <TableCell><code style={{ fontSize: '0.75rem' }}>male</code>, <code style={{ fontSize: '0.75rem' }}>female</code>, <code style={{ fontSize: '0.75rem' }}>prefer_not_to_say</code></TableCell>
                </TableRow>
                <TableRow>
                  <TableCell><Chip label="multiselect" size="small" color="info" variant="outlined" /></TableCell>
                  <TableCell>Multiple selections</TableCell>
                  <TableCell><code style={{ fontSize: '0.75rem' }}>skills</code>, <code style={{ fontSize: '0.75rem' }}>languages</code></TableCell>
                  <TableCell >--</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell><Chip label="boolean" size="small" color="success" variant="outlined" /></TableCell>
                  <TableCell>Yes/No questions</TableCell>
                  <TableCell><code style={{ fontSize: '0.75rem' }}>hasExperience</code></TableCell>
                  <TableCell >--</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell><Chip label="location" size="small" color="success" variant="outlined" /></TableCell>
                  <TableCell>Location Component</TableCell>
                  <TableCell><code style={{ fontSize: '0.75rem' }}>currentAddress</code></TableCell>
                  <TableCell >--</TableCell>
                </TableRow>
                {/* <TableRow>
                  <TableCell><Chip label="file" size="small" color="error" variant="outlined" /></TableCell>
                  <TableCell>File uploads</TableCell>
                  <TableCell><code style={{ fontSize: '0.75rem' }}>resume</code>, <code style={{ fontSize: '0.75rem' }}>profilePhoto</code></TableCell>
                </TableRow> */}
              </TableBody>
            </Table>
          </TableContainer>
        </Paper>
      )}

      {/* Section 7: Important Notes */}
      {/* <Alert severity="warning" sx={{ border: "2px solid #ff9800" }}>
        <Typography variant="body2" sx={{ fontWeight: 700, mb: 1 }}>⚠️ Important Notes:</Typography>
        <Typography variant="body2" component="div">
          • Changing field keys in existing forms may break data integration<br />
          • Always coordinate with your team before modifying standard keys<br />
          • Export forms regularly as backups<br />
          • Contact admin if you need to add new standard keys<br />
          • Test forms thoroughly before activating them
        </Typography>
      </Alert> */}
    </Box>
  );
};

export default FormGuidelines;
